<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BackstageButton from '../../../components/common/BackstageButton.vue';
import { ButtonVariant } from '../../../models/button-variant.enum';
import AuthorCard from './AuthorCard.vue';
import SectionContainer from './SectionContainer.vue';

interface Props {
  authorName: string;
  authorTitle: string;
  authorAvatarUrl: string;
  authorEmail: string;
}

defineProps<Props>();

const { t } = useI18n();
</script>

<template>
  <SectionContainer section-title="section-contact">
    <div class="contact-container">
      <h2 data-cy="contact-title" class="contact-title">{{ t('viewSelfSellIn.contact_info.title') }}</h2>
      <div class="contact-card">
        <AuthorCard
          class="contact-card-author"
          v-if="authorName"
          :authorName="authorName"
          :authorTitle="authorTitle"
          :authorAvatarUrl="authorAvatarUrl" />

        <BackstageButton
          class="contact-email"
          :variant="ButtonVariant.PRIMARY"
          data-cy-button="contact-email"
          :href="`mailto:${authorEmail}`">
          {{ t('viewSelfSellIn.contact_info.contact') }}
        </BackstageButton>
      </div>
    </div>
  </SectionContainer>
</template>

<style lang="scss" scoped>
.contact-container {
  display: grid;
  grid-template-columns: 1fr;

  @include respond-to(tablet) {
    grid-template-columns: 2fr 1fr;
  }

  .contact-title {
    justify-self: start;
    margin: 0;
    flex: 0 0 auto;
    font-weight: 700;
    font-size: 2.25rem;
    line-height: 1.1;
    letter-spacing: -0.72px;
  }
  .contact-card:deep() {
    .author-card__name,
    .author-card__title {
      color: var(--primary-text-color);
      font-size: 1.125rem;
    }
  }

  .contact-card-author + .contact-email {
    margin-top: 24px;
  }
}
</style>
